// extracted by mini-css-extract-plugin
export default {"sectionTitle":"views-CheckoutPage-SectionTitle-styles__sectionTitle--gjiUX"};